import React from "react";
import styles from "../styles/cardContent";

function CardContent({ iconName, iconText }) {
  return (
    <div style={styles}>
      <img
        src={`https://cdn-s3.touchofmodern.com/partners/assets/icon_${iconName}%402x.png`}
        height="75"
        width="75"
        alt={`${iconName}`}
      />
      <div style={{ marginTop: "15px" }}>{iconText}</div>
    </div>
  );
}

export default CardContent;
